@if (ticket1 && ticket2) {
  <app-booked-flight-ticket [tickets]="[ticket1, ticket2]" [status]="status"
    (copyValue)="copyText($event)" (copyTicketNumber)="copyText($event, 'Ticket copiado')"
    (cancelRequested)="cancelTicket()">
  </app-booked-flight-ticket>
}
